module.exports = __webpack_public_path__ + "media/images/favicons/favicon-9a21f29b0d2b4ac30b32423182f55802.ico";